import { uploadsFolder } from "~config";
import { ExtendedFile } from "~graphql/sdk";

export const getImageSrc = (
  image: ExtendedFile | string,
  fallback: string = undefined
): string => {
  if (!image) {
    return fallback ?? "/static/no-image.jpg";
  }

  if (typeof image === "string") {
    return image;
  }

  return `${uploadsFolder}/${image.directory}/${image.fileName}`;
};
